export const inputValidStyle = 'border border-solid outline-none border-gray hover:border-primary-hover active:border-primary-text focus:border-primary-text rounded';
//# sourceMappingURL=inputValidStyle.js.map